import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const formatINR = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(Number(n) || 0);

export const CATEGORIES = [
  "Gemstone Jewellery",
  "Fashion Jewellery",
];

export const SUBCATEGORIES = {
  "Gemstone Jewellery": ["Necklace", "Bracelet", "Earrings", "Pendants", "Artifacts"],
  "Fashion Jewellery": ["Necklace", "Bracelet", "Earrings", "Pendants"],
};

export const slugify = (s) =>
  s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const apiError = (e, fallback = "Something went wrong. Please try again.") => {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg).filter(Boolean).join(" ");
  return fallback;
};
